export const INDICATOR_TYPES = ["A", "B", "C"];
export const INDICATOR_FORMATS = ["double", "string"];
export const INDICATOR_UNITS = [
  "item",
  "Rub",
  "percent",
  "ThndRub",
  "MilnRub",
  "Unit",
  "Place",
];
export const INDICATOR_PERIODS = ["day", "month", "quarter", "year"];
